<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'tabs.account.page.calendar.upcomingEvents'|translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="list">
    <div class="schedule" *ngFor="let schedule of schedules; let i = index;">
      <h1><span>{{ schedule.title }}</span><ion-note>{{ schedule.scheduleTime | date: 'MMM d' }}</ion-note></h1>
      <p>{{ schedule.message }}</p>
    </div>
  </div>

  <ion-button (click)="dismiss()">{{ 'common.ok' | translate }}</ion-button>
</ion-content>